export default function SelectiveProcess() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: '01',
      title: 'Cadastro',
      description: 'Preencha o formulário com suas informações'
    },
    {
      number: '02',
      title: 'Comprovação',
      description: 'Envio de comprovação de atuação profissional'
    },
    {
      number: '03',
      title: 'Avaliação',
      description: 'Análise do perfil e experiência'
    },
    {
      number: '04',
      title: 'Retorno',
      description: 'Retorno individual sobre a candidatura'
    },
    {
      number: '05',
      title: 'Confirmação',
      description: 'Confirmação de vaga + cronograma'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
            Processo Seletivo
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Um processo criterioso para garantir que você está pronto para a AAPEQ
          </p>
        </div>

        {/* Steps Flow */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-3xl p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer">
                <div className="text-6xl font-black text-[#F05954] opacity-20 mb-3">
                  {step.number}
                </div>
                <h3 className="text-base font-bold text-[#262364] mb-2">
                  {step.title}
                </h3>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {/* Arrow */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-[#F05954]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Impact Quote */}
        <div className="text-center mb-12">
          <p className="text-2xl lg:text-3xl font-serif italic text-[#262364] max-w-3xl mx-auto leading-relaxed">
            <span className="text-[#F05954] text-4xl">"</span>
            A AAPEQ não é para curiosos. É para quem já está em movimento.
            <span className="text-[#F05954] text-4xl">"</span>
          </p>
        </div>

        {/* CTA */}
        <div className="text-center px-5 sm:px-0">
          <a
            href="https://wa.me/5511964187853?text=Ol%C3%A1%21+Vim+pelo+site+%E2%80%94+Se%C3%A7%C3%A3o+Processo+Seletivo+%E2%80%94+Quero+fazer+parte+da+AAPEQ"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full sm:w-auto bg-[#F05954] text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-[#d94943] transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Quero Fazer Parte da AAPEQ
          </a>
        </div>
      </div>
    </section>
  );
}
